export default function initGtm (configEmpresa) {
  const gtm = configEmpresa.gtm

  if (gtm) {
    (function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      var f = d.getElementsByTagName(s)[0]
      var j = d.createElement(s)
      var dl = l !== 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', gtm)

    let gtmScript = document.createElement('noscript')
    let gtmIframe = document.createElement('iframe')
    gtmIframe.setAttribute('src', 'https://www.googletagmanager.com/ns.html?id=' + gtm + '')
    gtmIframe.setAttribute('height', '0')
    gtmIframe.setAttribute('width', '0')
    gtmIframe.setAttribute('style', 'display:none;visibility:hidden')
    gtmScript.appendChild(gtmIframe)
    document.body.appendChild(gtmScript)
  }
}
